import { render, staticRenderFns } from "./PCTransfer.vue?vue&type=template&id=6e80a8e7"
import script from "./PCTransfer.vue?vue&type=script&lang=js"
export * from "./PCTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports